<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  menus: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['edit', 'delete']);

const { t } = useI18n();
</script>

<template>
  <tbody class="divide-y divide-n-weak">
    <tr v-for="menu in menus" :key="menu.id" class="hover:bg-n-alpha-1">
      <td class="py-4 ltr:pr-4 rtl:pl-4">
        <div class="flex items-center gap-2">
          <span
            :class="menu.icon"
            class="size-5 text-n-slate-12 flex-shrink-0"
          />
          <span class="font-medium text-n-slate-12">{{ menu.name }}</span>
        </div>
      </td>
      <td class="py-4 ltr:pr-4 rtl:pl-4">
        <a
          :href="menu.url"
          target="_blank"
          rel="noopener noreferrer"
          class="text-woot-500 hover:text-woot-600 hover:underline truncate max-w-[300px] block"
        >
          {{ menu.url }}
        </a>
      </td>
      <td class="py-4 ltr:pr-4 rtl:pl-4">
        <span
          class="px-2 py-1 text-xs rounded-full"
          :class="
            menu.enabled
              ? 'bg-n-teal-2 text-n-teal-11'
              : 'bg-n-slate-3 text-n-slate-11'
          "
        >
          {{
            menu.enabled
              ? t('CUSTOM_MENU.STATUS.ENABLED')
              : t('CUSTOM_MENU.STATUS.DISABLED')
          }}
        </span>
      </td>
      <td class="py-4 ltr:pr-4 rtl:pl-4">
        <div class="flex gap-2">
          <Button
            faded
            slate
            size="sm"
            icon="i-lucide-pencil"
            :label="$t('CUSTOM_MENU.EDIT.BUTTON_TEXT')"
            @click="emit('edit', menu)"
          />
          <Button
            faded
            ruby
            size="sm"
            icon="i-lucide-trash-2"
            :label="$t('CUSTOM_MENU.DELETE.BUTTON_TEXT')"
            :is-loading="loading[menu.id]"
            @click="emit('delete', menu)"
          />
        </div>
      </td>
    </tr>
  </tbody>
</template>
